import {BidMapBidDto} from '@6grain/masofa-monolith-api-client/crop-monitoring/model/bidMapBidDto';

export function escapeBidMapHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function buildGroundSurveyPinDivIconHtml(fill: string): string {
  return (
    `<div class="gis-bid-marker gis-bid-marker--ground-survey" style="width:25px;height:41px;line-height:0;">` +
    `<svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg" style="display:block">` +
    `<path d="M12.5 0C5.596 0 0 5.596 0 12.5c0 2.902 1.004 5.57 2.68 7.682L12.5 41l9.82-20.818C23.996 18.07 25 15.402 25 12.5 25 5.596 19.404 0 12.5 0z" fill="${fill}"/>` +
    `<circle cx="12.5" cy="12.5" r="6" fill="white"/></svg></div>`
  );
}

export function resolveBidIdFromMapDto(bid: BidMapBidDto): string | null {
  const r = bid as BidMapBidDto & {id?: string | null; bidId?: string | null};
  const id = r.id ?? r.bidId;
  if (id != null && String(id).trim().length) {
    return String(id).trim();
  }
  return null;
}
